

<p class="{{data.type}}">
    <mat-icon>{{icon}}</mat-icon>
    {{data.msg}}
</p>

<!-- error -> Warning icon -->

<!-- cancel -> Error icon -->